import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userInfoOperations, userInfoSelectors } from '../state/ducks/user';

const useHideHeader = () => {
  const { search } = useLocation();
  const queryParameter = new URLSearchParams(search);
  const dispatch = useDispatch();
  const { userFromApp } = useSelector(userInfoSelectors.getuserInfoState);

  useEffect(() => {
    if (!userFromApp && queryParameter.get('fromApp')) {
      dispatch(userInfoOperations.userFromApp());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userFromApp, dispatch]);
};

export { useHideHeader };
